const REFERRAL_COOKIE_NAME = 'thera_referral_code';
const REFERRAL_COOKIE_DAYS = 30;
const REFERRAL_LS_KEY = 'thera_referral_code';
const REFERRAL_LS_TIMESTAMP_KEY = 'thera_referral_code_ts';
const REFERRAL_MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000; // 30 days
export const REFERRAL_QUERY_PARAM = 'ref';

/**
 * Persist a referral slug to both cookie and localStorage.
 */
export function saveReferralSlug(slug: string): void {
  // Cookie (fallback, existing behavior)
  const expires = new Date();
  expires.setDate(expires.getDate() + REFERRAL_COOKIE_DAYS);
  document.cookie = `${REFERRAL_COOKIE_NAME}=${encodeURIComponent(slug)}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;

  // localStorage (more reliable — survives cross-domain redirects)
  try {
    localStorage.setItem(REFERRAL_LS_KEY, slug);
    localStorage.setItem(REFERRAL_LS_TIMESTAMP_KEY, Date.now().toString());
  } catch {
    // private browsing may throw
  }
}

/**
 * Retrieve the referral slug. Priority: localStorage → cookie.
 * Returns null if nothing stored or if expired (30 days).
 */
export function getReferralSlug(): string | null {
  // Try localStorage first (most reliable)
  try {
    const slug = localStorage.getItem(REFERRAL_LS_KEY);
    const ts = localStorage.getItem(REFERRAL_LS_TIMESTAMP_KEY);
    if (slug && ts) {
      if (Date.now() - Number(ts) < REFERRAL_MAX_AGE_MS) return slug;
      clearReferralSlug();
      return null;
    }
  } catch {
    // ignore
  }

  // Fall back to cookie
  if (typeof document === 'undefined') return null;
  const match = document.cookie.split('; ').find((row) => row.startsWith(REFERRAL_COOKIE_NAME + '='));
  return match ? decodeURIComponent(match.split('=')[1]) : null;
}

/**
 * Clear the referral slug from all storage mechanisms.
 */
export function clearReferralSlug(): void {
  try {
    localStorage.removeItem(REFERRAL_LS_KEY);
    localStorage.removeItem(REFERRAL_LS_TIMESTAMP_KEY);
  } catch {
    // ignore
  }
  document.cookie = `${REFERRAL_COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
}

/**
 * Append ?ref=slug (or &ref=slug) to a URL. Returns url unchanged if slug is null.
 */
export function appendRefParam(url: string, slug: string | null): string {
  if (!slug) return url;
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}${REFERRAL_QUERY_PARAM}=${encodeURIComponent(slug)}`;
}
